import React from 'react';
import './mro.css'
import MROimage from '../../Images/MRO.jpg';

function mro() {
    return (
    <section>
      <section className='MRO-container'>
        <div className='MRO-image'>
          <img src={MROimage}></img>
        </div>
        <div className='MRO-info'>
          <div className='MRO-info-title'><h1>MRO</h1></div>
          <div className='MRO-info-subtitle'><h2>Mantenimiento, Reparacion, Operaciones</h2></div>
          <div className='MRO-info-info'><p>El MRO abarca una amplia variedad de tareas, desde el mantenimiento preventivo y correctivo, hasta la reparación y el reemplazo de piezas. Además, incluye la gestión de inventarios de suministros y la realización de tareas operativas para asegurar el correcto funcionamiento de los equipos en la producción. </p></div>
          <div className='MRO-info-button'><h3>CONTROL ELECTRICO</h3></div>
          <br></br>
          <div className='MRO-info-button'><h3>CONTROL NEUMATICO</h3></div>
        </div>
      </section>
    </section>
    );
  }
  
export default mro;
  